import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { Store } from '@ngrx/store';
import { FiltroPageActions } from '../_state/actions';
import { getCursos, getError, getLoading, getSelectedCursos, State } from '../_state/filtro.selector';
import * as Models from '../_models';
@Component({
  selector: 'app-filtro-curso',
  standalone: false,
  templateUrl: 'filtro-curso.component.html',
  styleUrls: ['../filtro.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class FiltroCursoComponent implements OnInit {

  @ViewChild("cursoSelect") cursoSelect: MatSelect;
  @ViewChild("cursoTodos") private cursoTodos: MatOption;
  @ViewChild("cursoNuevos") private cursoNuevos: MatOption;

  @Output() selected = new EventEmitter<number[]>();
  @Input() soloActivos = true;
  @Input() includeCursosN = false;
  @Input() includeSinHijos = false;
  @Input() parentOnly = false;
  @Input() parentSelect = false;

  cursos$ = this.store.select(getCursos);
  selectedCursos$ = this.store.select(getSelectedCursos);
  errorMessage$ = this.store.select(getError);
  loading$ = this.store.select(getLoading);

  constructor(private store: Store<State>) { }

  ngOnInit() {
    this.store.dispatch(FiltroPageActions.loadCursos({ soloActivos: this.soloActivos }));
  }

  doSelected(event: any) {
    if (this.cursoNuevos?.selected) {
      this.store.dispatch(FiltroPageActions.selectedIsNuevo(
        { selectedIsNuevo: this.cursoNuevos.selected })
      );
    } else if (this.cursoNuevos?.selected === false) {
      this.store.dispatch(FiltroPageActions.selectedIsNuevo(
        { selectedIsNuevo: this.cursoNuevos.selected })
      );
    }
    if (this.cursoTodos.selected) {
      this.store.dispatch(FiltroPageActions.cleanSelectedCursos());
      this.selected.emit([]);
    } else {
      this.store.dispatch(FiltroPageActions.selectedCursos(
        { selectedCursos: event?.value.filter((i) => i > 0) ?? [] }
      ));
      this.selected.emit(event?.value.filter((i) => i > 0) ?? []);
    }
    // this.cursoSelect.close();
  }
  curso(index: number, curso: Models.CursoDto) {
    return curso.id;
  }
  salon(index: number, salon: Models.CursoDto) {
    return salon.id;
  }

}
